var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _g2, _path23, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoloroviLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 347,
    viewBox: "0 0 416 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_225)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.837447 333.447C2.37266 334.418 4.14009 334.958 5.95477 335.01C8.77525 335.01 10.0962 333.614 10.1081 331.837C10.12 330.059 9.01327 328.962 6.14518 327.888C2.31314 326.504 0.50422 324.369 0.516121 321.804C0.516121 318.357 3.3128 315.529 7.90649 315.541C9.73909 315.521 11.5461 315.973 13.1547 316.854L12.1789 319.681C10.8608 318.887 9.34909 318.474 7.81129 318.488C5.51445 318.488 4.24106 319.812 4.24106 321.399C4.24106 322.985 5.51444 323.975 8.28732 324.977C11.9885 326.409 13.8926 328.27 13.8807 331.467C13.8807 335.225 10.9412 337.873 5.85956 337.849C3.78214 337.878 1.73253 337.368 -0.0908203 336.37L0.837447 333.447Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0325 337.61L57.735 334.914H57.6041C56.8402 335.923 55.8487 336.735 54.7109 337.284C53.573 337.834 52.3214 338.105 51.0587 338.076C50.2182 338.135 49.3745 338.019 48.581 337.735C47.7875 337.451 47.0613 337.005 46.4485 336.426C45.8356 335.846 45.3493 335.145 45.0203 334.368C44.6913 333.59 44.5268 332.753 44.5371 331.908C44.5371 326.731 49.1546 323.915 57.4137 323.975V323.534C57.4137 321.768 56.9496 318.583 52.5701 318.571C50.6068 318.563 48.6809 319.109 47.0124 320.146L46.1318 317.569C48.2521 316.3 50.6843 315.652 53.1532 315.696C59.6868 315.696 61.2696 320.182 61.2577 324.476V332.493C61.2186 334.209 61.3301 335.925 61.5909 337.622L58.0325 337.61ZM57.497 326.683C53.2603 326.576 48.4405 327.315 48.4286 331.455C48.3862 331.949 48.4511 332.447 48.6188 332.914C48.7866 333.381 49.0532 333.805 49.4004 334.159C49.7476 334.513 50.1671 334.787 50.63 334.963C51.0929 335.138 51.5884 335.211 52.0822 335.177C53.2125 335.209 54.3237 334.88 55.2546 334.236C56.1855 333.593 56.8876 332.669 57.259 331.598C57.3935 331.214 57.4697 330.812 57.4851 330.405L57.497 326.683Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8891 323.307C94.8891 320.563 94.8177 318.344 94.7344 316.317H98.2332L98.3879 319.979H98.4831C99.2508 318.657 100.366 317.572 101.707 316.842C103.048 316.112 104.563 315.765 106.088 315.839C111.253 315.839 115.12 320.253 115.108 326.755C115.108 334.449 110.348 338.242 105.35 338.231C104.056 338.281 102.772 337.996 101.621 337.402C100.47 336.809 99.4915 335.927 98.7806 334.843H98.6973V346.486H94.8534L94.8891 323.307ZM98.7211 329.021C98.7244 329.558 98.7802 330.094 98.8877 330.62C99.2109 331.924 99.9587 333.082 101.013 333.912C102.067 334.741 103.367 335.195 104.707 335.201C108.813 335.201 111.205 331.86 111.217 326.945C111.217 322.651 108.991 318.965 104.886 318.953C103.506 318.973 102.172 319.453 101.095 320.317C100.017 321.181 99.2577 322.38 98.9353 323.725C98.7818 324.24 98.6938 324.773 98.6735 325.311L98.7211 329.021Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.372 323.474C147.372 320.73 147.3 318.524 147.217 316.484H150.704L150.87 320.158H150.942C151.715 318.841 152.832 317.76 154.172 317.031C155.511 316.302 157.023 315.952 158.546 316.018C163.723 316.018 167.591 320.432 167.567 326.934C167.567 334.64 162.807 338.421 157.82 338.41C156.527 338.463 155.241 338.178 154.09 337.585C152.938 336.991 151.96 336.108 151.251 335.022H151.168V346.665H147.372V323.474ZM151.192 329.2C151.199 329.734 151.259 330.265 151.37 330.787C151.681 332.095 152.424 333.259 153.479 334.09C154.533 334.922 155.836 335.372 157.178 335.368C161.284 335.368 163.676 332.027 163.699 327.113C163.699 322.818 161.474 319.144 157.356 319.12C155.99 319.158 154.673 319.645 153.611 320.508C152.548 321.37 151.798 322.559 151.477 323.892C151.319 324.411 151.227 324.948 151.204 325.49L151.192 329.2Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.925 306.654H203.805V320.015H203.888C204.549 318.861 205.518 317.915 206.685 317.283C207.89 316.571 209.261 316.193 210.66 316.185C213.528 316.185 218.11 317.987 218.086 325.371V338.123H214.194V325.824C214.194 322.377 212.933 319.454 209.267 319.442C208.102 319.46 206.971 319.844 206.034 320.54C205.097 321.235 204.401 322.207 204.043 323.319C203.837 323.913 203.744 324.54 203.769 325.168V338.099H199.89L199.925 306.654Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.108 310.817C256.108 311.45 255.858 312.057 255.411 312.504C254.965 312.952 254.36 313.203 253.728 313.203C253.097 313.203 252.492 312.952 252.045 312.504C251.599 312.057 251.348 311.45 251.348 310.817C251.348 310.184 251.599 309.578 252.045 309.13C252.492 308.683 253.097 308.431 253.728 308.431C254.044 308.421 254.357 308.476 254.651 308.593C254.944 308.709 255.21 308.885 255.433 309.108C255.656 309.332 255.831 309.599 255.947 309.893C256.064 310.187 256.118 310.501 256.108 310.817ZM251.693 338.254L251.765 316.782H255.668L255.609 338.254H251.693Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.443 323.617C289.443 321.1 289.443 318.929 289.289 316.937H292.68L292.799 321.148H292.978C293.349 319.838 294.125 318.68 295.194 317.84C296.263 317 297.571 316.521 298.928 316.472C299.297 316.468 299.665 316.512 300.023 316.603V320.277C299.589 320.185 299.146 320.141 298.702 320.146C295.965 320.146 294.013 322.21 293.478 325.132C293.364 325.73 293.304 326.337 293.299 326.945V338.362H289.467L289.443 323.617Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.952 328.496C333.024 333.769 336.38 335.94 340.259 335.952C342.298 336.034 344.33 335.663 346.21 334.866L346.864 337.658C344.603 338.595 342.17 339.042 339.724 338.97C333.143 338.97 329.227 334.592 329.251 328.126C329.275 321.661 333.083 316.591 339.307 316.615C346.281 316.615 348.114 322.794 348.102 326.731C348.095 327.338 348.047 327.943 347.959 328.544L332.952 328.496ZM344.353 325.741C344.353 323.271 343.354 319.418 338.986 319.394C335.059 319.394 333.321 322.973 333.036 325.705L344.353 325.741Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M379.722 334.664C381.256 335.637 383.024 336.177 384.839 336.226C387.672 336.226 388.993 334.831 389.005 333.065C389.017 331.3 387.91 330.178 385.042 329.105C381.21 327.721 379.401 325.598 379.413 323.033C379.413 319.573 382.209 316.758 386.803 316.77C388.638 316.757 390.445 317.217 392.051 318.106L391.075 320.945C389.765 320.127 388.252 319.693 386.708 319.693C384.411 319.693 383.138 321.005 383.138 322.591C383.138 324.369 384.411 325.168 387.184 326.242C390.885 327.661 392.777 329.534 392.765 332.719C392.765 336.477 389.838 339.125 384.756 339.113C382.68 339.13 380.633 338.622 378.806 337.634L379.722 334.664Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.504395 1.09824H15.3327V56.6289H15.8445C18.9149 52.1912 21.9853 48.0875 24.8772 44.3298L59.9963 1.09824H78.4068L36.7541 50.0081L81.5843 116.299H64.0664L26.2338 59.7543L15.3327 72.3039V116.204H0.504395V1.09824Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.296 1.09824H243.125V103.785H292.215V116.251H228.296V1.09824Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.504395 160.366C9.89929 158.69 19.429 157.891 28.971 157.98C44.8228 157.98 55.0456 160.89 62.2098 167.38C68.0055 172.51 71.2068 180.347 71.2068 189.21C71.2068 204.42 61.6862 214.5 49.5593 218.592V219.105C58.4254 222.183 63.7093 230.39 66.4346 242.343C70.1833 258.412 72.9086 269.518 75.3007 273.956H59.9963C58.116 270.711 55.5573 260.834 52.3203 246.447C48.9167 230.557 42.7997 224.581 29.3161 224.068H15.3327V273.956H0.504395V160.366ZM15.3327 212.854H30.5062C46.358 212.854 56.4142 204.134 56.4142 190.976C56.4142 176.112 45.7035 169.623 29.9945 169.503C25.0705 169.365 20.1478 169.822 15.3327 170.863V212.854Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.891 273.98L230.392 158.827H246.41L264.261 215.55C269.2 231.058 273.46 245.099 276.531 258.603H276.876C280.113 245.278 284.885 230.748 289.967 215.717L309.401 158.827H325.253L284.231 273.98H267.891Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M371.511 158.827V273.98H356.683V158.827H371.511Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.312 116.872C180.636 116.872 206.84 90.605 206.84 58.2035C206.84 25.8021 180.636 -0.464478 148.312 -0.464478C115.988 -0.464478 89.7842 25.8021 89.7842 58.2035C89.7842 90.605 115.988 116.872 148.312 116.872Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357.074 116.872C389.398 116.872 415.602 90.605 415.602 58.2035C415.602 25.8021 389.398 -0.464478 357.074 -0.464478C324.75 -0.464478 298.546 25.8021 298.546 58.2035C298.546 90.605 324.75 116.872 357.074 116.872Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.633 273.932C180.957 273.932 207.161 247.665 207.161 215.264C207.161 182.862 180.957 156.596 148.633 156.596C116.309 156.596 90.105 182.862 90.105 215.264C90.105 247.665 116.309 273.932 148.633 273.932Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.633 258.794C172.616 258.794 192.059 239.305 192.059 215.264C192.059 191.223 172.616 171.734 148.633 171.734C124.649 171.734 105.207 191.223 105.207 215.264C105.207 239.305 124.649 258.794 148.633 258.794Z",
    fill: "#FBF192"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.312 101.733C172.295 101.733 191.737 82.2444 191.737 58.2035C191.737 34.1627 172.295 14.6737 148.312 14.6737C124.328 14.6737 104.886 34.1627 104.886 58.2035C104.886 82.2444 124.328 101.733 148.312 101.733Z",
    fill: "#E4F2F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M357.075 101.733C381.058 101.733 400.501 82.2444 400.501 58.2035C400.501 34.1627 381.058 14.6737 357.075 14.6737C333.091 14.6737 313.649 34.1627 313.649 58.2035C313.649 82.2444 333.091 101.733 357.075 101.733Z",
    fill: "#F8D0E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_225",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 5,
    width: 107,
    height: 107
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.883 111.11C177.184 111.11 200.937 87.4388 200.937 58.2393C200.937 29.0398 177.184 5.3689 147.883 5.3689C118.582 5.3689 94.8296 29.0398 94.8296 58.2393C94.8296 87.4388 118.582 111.11 147.883 111.11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2451 37.2319L108.254 41.8366L109.872 20.0538C109.872 20.0538 101.327 27.3545 98.2451 37.2319Z",
    fill: "#B9E1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 41.8366L125.164 35.4544L130.901 19.0995L109.872 20.0538L108.253 41.8366Z",
    fill: "#CFE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.872 20.0538L130.901 19.0994L126.712 8.70908C120.632 11.744 114.972 15.5575 109.872 20.0538Z",
    fill: "#C7E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 19.0994L147.883 4.90364C140.647 4.79772 133.459 6.08973 126.711 8.70907L130.9 19.0994Z",
    fill: "#B4BACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 19.0995L147.883 4.90366L164.544 19.0995L147.728 26.2928L130.9 19.0995Z",
    fill: "#FAFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 4.90365L164.544 19.0995L186.548 20.7218C186.548 20.7218 169.637 3.56757 147.883 4.90365Z",
    fill: "#B7E0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.544 19.0995L169.792 35.7885L187.691 41.8366L186.548 20.7218L164.544 19.0995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.548 20.7218C186.548 20.7218 194.974 29.7881 197.485 37.1603L187.691 41.8366L186.548 20.7218Z",
    fill: "#57A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.729 26.2928L164.544 19.0995L169.793 35.7885L147.729 26.2928Z",
    fill: "#D7EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.165 35.4545L147.728 26.2928L130.901 19.0995L125.165 35.4545Z",
    fill: "#A5D9F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 41.8366L125.164 35.4544L115.644 58.0604L108.253 41.8366Z",
    fill: "#AAD5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 41.8366L98.2449 37.2319C98.2449 37.2319 94.0558 48.2307 94.0439 58.8477L108.253 41.8366Z",
    fill: "#80BAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 41.8366L94.0439 58.8477L108.253 74.8686L115.644 58.0603L108.253 41.8366Z",
    fill: "#53ABCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0439 58.8477C94.0439 58.8477 94.0439 71.5643 98.6852 79.879L108.206 74.8687L94.0439 58.8477Z",
    fill: "#438AA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6851 79.8789L108.206 74.8687L109.824 96.055C109.824 96.055 101.982 89.2195 98.6851 79.8789Z",
    fill: "#0F1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 74.8687L125.164 80.7617L130.901 97.9279L109.872 96.055L108.253 74.8687Z",
    fill: "#0D497F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.872 96.055C109.872 96.055 120.583 105.229 126.712 107.4L130.901 97.9279L109.872 96.055Z",
    fill: "#064167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 97.9279L126.711 107.4C126.711 107.4 139.255 111.587 147.883 111.706L130.9 97.9279Z",
    fill: "#1F5A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 97.9279L147.883 90.2455L164.544 97.9279L147.883 111.706L130.9 97.9279Z",
    fill: "#2E7EB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.901 97.9279L125.165 80.7617L147.883 90.2455L130.901 97.9279Z",
    fill: "#629ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253 74.8687L115.644 58.0604L125.164 80.7617L108.253 74.8687Z",
    fill: "#46809A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 90.2455L170.946 80.7617L164.544 97.9279L147.883 90.2455Z",
    fill: "#566779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.883 111.67L164.544 97.8921L169.042 107.364C169.042 107.364 161.569 111.754 147.883 111.67Z",
    fill: "#1C3052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.544 97.9279L185.882 96.055C185.882 96.055 177.468 104.405 169.042 107.4L164.544 97.9279Z",
    fill: "#0B4D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.882 96.055L186.549 74.8687L197.486 78.9485C197.486 78.9485 192.13 89.4462 185.882 96.055Z",
    fill: "#3680AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.548 74.8687L170.947 79.8789L164.544 97.9279L185.882 96.055L186.548 74.8687Z",
    fill: "#C0E4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.947 80.7617L179.979 58.0604L186.549 74.8687L170.947 80.7617Z",
    fill: "#5CA2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.001 75.322L202.163 58.3944L187.691 41.8366L179.979 58.0603L187.001 75.322Z",
    fill: "#6BB7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.001 75.322L202.115 58.3944C202.115 58.3944 202.472 72.7095 197.438 78.9485L187.001 75.322Z",
    fill: "#1E335A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.639 57.2015L187.691 41.8366L197.485 37.1603C197.485 37.1603 201.639 44.6758 201.722 58.0604",
    fill: "#1B2543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.98 58.0603L169.792 35.7885L187.691 41.8366L179.98 58.0603Z",
    fill: "#C1E3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.165 35.4544L147.729 26.2928L169.792 35.7885L179.98 58.0604L170.947 80.7617L147.883 90.2455L125.165 80.7617L115.644 58.0604L125.165 35.4544Z",
    fill: "#EAF5FC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_185_225",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 5,
    width: 107,
    height: 106
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.55 110.287C386.792 110.287 410.497 86.8347 410.497 57.9053C410.497 28.9759 386.792 5.52396 357.55 5.52396C328.309 5.52396 304.604 28.9759 304.604 57.9053C304.604 86.8347 328.309 110.287 357.55 110.287Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_185_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.626 36.8859L317.694 41.4787L319.325 19.7317C319.325 19.7317 310.733 26.9727 307.626 36.8859Z",
    fill: "#F9E6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 41.4787L334.701 35.1085L340.485 18.7773L319.325 19.7317L317.695 41.4787Z",
    fill: "#F6D2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.325 19.7317L340.485 18.7774L336.272 8.39893C330.16 11.4296 324.464 15.2387 319.325 19.7317Z",
    fill: "#E8B9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.485 18.7774L357.562 4.60542C350.289 4.49964 343.063 5.78721 336.272 8.39892L340.485 18.7774Z",
    fill: "#B4BACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.485 18.7773L357.562 4.60541L374.331 18.7773L357.408 25.9707L340.485 18.7773Z",
    fill: "#F9E6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.562 4.60541L374.33 18.7773L396.466 20.3997C396.466 20.3997 379.436 3.26933 357.562 4.60541Z",
    fill: "#EDD6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.331 18.7773L379.615 35.4425L397.608 41.4787L396.466 20.3997L374.331 18.7773Z",
    fill: "#FCF6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.466 20.3997C396.466 20.3997 404.939 29.454 407.462 36.8144L397.608 41.4787L396.466 20.3997Z",
    fill: "#E8B9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.408 25.9707L374.331 18.7773L379.615 35.4425L357.408 25.9707Z",
    fill: "#F2CED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.701 35.1085L357.407 25.9707L340.484 18.7773L334.701 35.1085Z",
    fill: "#EDD6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 41.4787L334.701 35.1085L325.133 57.6786L317.695 41.4787Z",
    fill: "#FBF2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 41.4787L307.627 36.886C307.627 36.886 303.414 47.8728 303.402 58.4779L317.695 41.4787Z",
    fill: "#E8B9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 41.4787L303.402 58.4779L317.695 74.475L325.133 57.6786L317.695 41.4787Z",
    fill: "#F6D2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.402 58.4779C303.402 58.4779 303.402 71.1706 308.067 79.4733L317.695 74.475L303.402 58.4779Z",
    fill: "#E8B9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.031 79.4614L317.659 74.4631L319.289 95.6136C319.289 95.6136 311.387 88.802 308.031 79.4614Z",
    fill: "#904B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 74.475L334.701 80.3561L340.485 97.4984L319.325 95.6256L317.695 74.475Z",
    fill: "#C2A6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.325 95.6255C319.325 95.6255 330.131 104.787 336.272 106.958L340.485 97.4984L319.325 95.6255Z",
    fill: "#BF789D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.485 97.4984L336.272 106.958C336.272 106.958 348.887 111.146 357.562 111.265L340.485 97.4984Z",
    fill: "#B16F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.485 97.4984L357.562 89.8279L374.331 97.4984L357.562 111.265L340.485 97.4984Z",
    fill: "#E8B9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.484 97.4984L334.701 80.3561L357.562 89.8279L340.484 97.4984Z",
    fill: "#F6D2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.695 74.475L325.133 57.6786L334.701 80.3561L317.695 74.475Z",
    fill: "#B16F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.562 89.8279L380.768 80.3561L374.33 97.4984L357.562 89.8279Z",
    fill: "#C2A6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.562 111.265L374.33 97.4984L378.852 106.958C378.852 106.958 371.343 111.301 357.562 111.265Z",
    fill: "#CF8CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.331 97.4984L395.752 95.6255C395.752 95.6255 387.279 103.976 378.805 106.958L374.331 97.4984Z",
    fill: "#BF789D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.799 95.6255L396.466 74.475L407.462 78.5548C407.462 78.5548 402.047 89.0048 395.799 95.6255Z",
    fill: "#B16F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.466 74.475L380.769 79.4733L374.331 97.4984L395.8 95.6256L396.466 74.475Z",
    fill: "#FCF6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.769 80.3561L389.849 57.6786L396.466 74.475L380.769 80.3561Z",
    fill: "#B4BACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.918 74.9164L412.175 58.0246L397.608 41.4787L389.849 57.6786L396.918 74.9164Z",
    fill: "#F6D2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.918 74.9283L412.175 57.9888C412.175 57.9888 412.532 72.3039 407.414 78.519L396.918 74.9283Z",
    fill: "#904B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.639 56.7959L397.608 41.4429L407.462 36.7786C407.462 36.7786 411.639 44.2821 411.723 57.6429",
    fill: "#B16F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.849 57.6786L379.614 35.4425L397.608 41.4787L389.849 57.6786Z",
    fill: "#EDD6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.701 35.1085L357.408 25.9707L379.614 35.4425L389.849 57.6786L380.769 80.3561L357.562 89.8279L334.701 80.3561L325.133 57.6786L334.701 35.1085Z",
    fill: "#F9E6F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_185_225",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 162,
    width: 106,
    height: 106
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.061 267.514C178.007 267.514 201.472 244.116 201.472 215.252C201.472 186.389 178.007 162.99 149.061 162.99C120.116 162.99 96.6504 186.389 96.6504 215.252C96.6504 244.116 120.116 267.514 149.061 267.514Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_185_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.173 194.149L110.063 198.742L111.658 177.031C111.658 177.031 103.22 184.308 100.173 194.149Z",
    fill: "#F3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.062 198.742L126.771 192.384L132.436 176.076L111.657 177.031L110.062 198.742Z",
    fill: "#EBEFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.669 177.031L132.448 176.076L128.33 165.722C122.308 168.746 116.707 172.548 111.669 177.031Z",
    fill: "#F9F3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.436 176.088L149.216 161.94C142.076 161.833 134.982 163.117 128.331 165.722L132.436 176.088Z",
    fill: "#DFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.436 176.076L149.216 161.928L165.675 176.076L149.061 183.246L132.436 176.076Z",
    fill: "#F7F4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.216 161.928L165.675 176.088L187.418 177.711C187.418 177.711 170.709 160.58 149.216 161.928Z",
    fill: "#FAF090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.675 176.076L170.864 192.706L188.536 198.742L187.417 177.699L165.675 176.076Z",
    fill: "#F8F8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.417 177.699C187.417 177.699 195.748 186.729 198.223 194.078L188.536 198.754L187.417 177.699Z",
    fill: "#F3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.062 183.246L165.675 176.076L170.864 192.706L149.062 183.246Z",
    fill: "#F3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.771 192.384L149.062 183.246L132.436 176.076L126.771 192.384Z",
    fill: "#F8D575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.062 198.742L126.771 192.384L117.358 214.918L110.062 198.742Z",
    fill: "#FBEF7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.063 198.754L100.173 194.161C100.173 194.161 96.0436 205.124 96.0317 215.717L110.063 198.754Z",
    fill: "#FAF090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.063 198.742L96.0317 215.705L110.063 231.679L117.358 214.918L110.063 198.742Z",
    fill: "#F4C045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 215.705C96.0317 215.705 96.0317 228.374 100.602 236.665L110.122 231.679L96.0317 215.705Z",
    fill: "#F3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.602 236.665L110.122 231.679L111.669 252.793C111.669 252.793 103.874 245.982 100.602 236.665Z",
    fill: "#D8943D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.062 231.679L126.771 237.548L132.436 254.666L111.657 252.793L110.062 231.679Z",
    fill: "#F3C484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.669 252.793C111.669 252.793 122.285 261.943 128.33 264.102L132.46 254.666L111.669 252.793Z",
    fill: "#AE7C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.436 254.666L128.331 264.102C128.331 264.102 140.719 268.278 149.24 268.397L132.436 254.666Z",
    fill: "#DFB607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.436 254.666L149.216 246.996L165.675 254.666L149.216 268.397L132.436 254.666Z",
    fill: "#DBCB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.436 254.666L126.771 237.548L149.216 246.996L132.436 254.666Z",
    fill: "#F4C045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.062 231.679L117.358 214.918L126.771 237.548L110.062 231.679Z",
    fill: "#FDF07E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.216 246.996L172.006 237.548L165.675 254.666L149.216 246.996Z",
    fill: "#FDF07E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.216 268.397L165.675 254.666L170.126 264.102C170.126 264.102 162.747 268.445 149.216 268.397Z",
    fill: "#F4C045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.675 254.666L186.763 252.793C186.763 252.793 178.432 261.144 170.102 264.102L165.675 254.666Z",
    fill: "#D7AB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.763 252.793L187.418 231.679L198.224 235.747C198.224 235.747 192.928 246.197 186.763 252.793Z",
    fill: "#FBED6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.417 231.679L172.006 236.665L165.675 254.666L186.763 252.793L187.417 231.679Z",
    fill: "#F8E6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.006 237.548L180.92 214.918L187.418 231.679L172.006 237.548Z",
    fill: "#F3C484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.858 232.12L202.841 215.252L188.536 198.742L180.92 214.918L187.858 232.12Z",
    fill: "#FAF090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.834 232.156L202.817 215.288C202.817 215.288 203.174 229.603 198.2 235.782L187.834 232.156Z",
    fill: "#EFA245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.329 214.071L188.536 198.754L198.223 194.09C198.223 194.09 202.329 201.581 202.401 214.93",
    fill: "#F4C045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.92 214.918L170.864 192.706L188.536 198.742L180.92 214.918Z",
    fill: "#F8D575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.771 192.384L149.062 183.246L170.864 192.706L180.92 214.918L172.006 237.548L149.216 246.996L126.771 237.548L117.358 214.918L126.771 192.384Z",
    fill: "#FAF090"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 347,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoloroviLogo);
export default __webpack_public_path__ + "static/media/koloroviLogo.00c89e91dff32226f4f5edb41c5d3eae.svg";
export { ForwardRef as ReactComponent };